<template>
  <a-modal :title="title" :visible="visible" :width="850" @cancel="handleCancel">
    <a-row>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan">任务描述：</span>
        <span class="contentSpan">{{ model.description }}</span>
      </a-col>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan">执行时间：</span>
        <span class="contentSpan">{{ model.executionTime }}</span>
      </a-col>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan">执行状态：</span>
        <span class="contentSpan">{{ model.status === 1 ? '成功' : '失败' }}</span>
      </a-col>
      <a-col :span="24" class="mb_15 logDiv">
        <span class="labelSpan">日志数据：</span>
        <div class="contentSpan logData">
          <span style="white-space:pre-wrap;">{{ model.content }}</span>
        </div>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 关闭 </a-button>
    </template>
  </a-modal>
</template>

<script>

import { timedTaskLogDetail } from '@/api/timingTask'

export default {
  name: 'ViewModules',
  data () {
    return {
      labelCol: { style: 'width: 100px' },
      wrapperCol: { style: 'width: calc(100% - 100px)' },
      title: '',
      type: '',
      model: {},
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      loading: false,
      day: '',
      zxpl: null,
      cc: '人员 已同步了 9649 条数据 \n人员 新增了：林欣,闫红平,潘一凡,吴宇枫,许嘉诚,李江,李江,李江,陈嘉琳,马歆桐,陈邵翔,方云根,张文平,李后齐,周世明,周宇杰,王晨栋,吴山石,何星宇,叶锦鹏,姚明睿,王鹏飞,钱凰,刘宏,黄有晨,夏颖,达州杭氧收文,卫泽恒,张浩然,徐劲聪,毛浩扬,傅禧如,吴云良,张浩燃,洪有根<br/>人员 删除了： \n'
    }
  },
  created () {},
  methods: {
    setTitle (title) {
      this.title = title
    },
    setType (type) {
      this.type = type
    },
    setModel (model) {
      timedTaskLogDetail({ logId: model.id }).then(res => {
        if (res.status === 0) {
          this.model = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {})
    },
    open (visible) {
      this.visible = visible
    },
    handleCancel () {
      this.model = {}
      this.form.resetFields()
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.mb_15 {
  margin-bottom: 15px;
}
.labelSpan {
  display: inline-block;
  text-align: right;
  width: 5rem;
}
.contentSpan {
  width: calc(100% - 5rem);
}
.logDiv {
  display: flex;
  flex-direction: row;
  .logData {
    width: calc(100% - 5rem);
    height: 170px;
    overflow: auto;
    border: 1px solid rgb(236, 236, 236);
    padding: 5px;
  }
}
</style>
